import React, { Component } from "react";
import "./Button.scss";
import PropTypes from "prop-types";

export class Button extends Component {
  render() {
    const {
      primary,
      secondary,
      tertiary,
      className,
      outline,
      warning,
      danger,
      isSubmitting,
      ...buttonProps
    } = this.props;
    return (
      <button
        type="button"
        className={`btn ${danger ? "btn-danger" : ""} r-button ${className} ${
          primary
            ? "primary"
            : secondary
            ? "secondary"
            : tertiary
            ? "tertiary"
            ? danger 
            : "danger"
            : "primary"
        }`}
        disabled={isSubmitting}
        {...buttonProps}
      >
        {this.props.children}
        {isSubmitting ? (
          <i className="fas fa-circle-notch fa-spin ml5" />
        ) : null}
      </button>
    );
  }
}

Button.propTypes = {
  primary: PropTypes.bool
};
